import React from "react";

export const LeftBanner: React.FC = () => {
  return (
    <>
      <div className="w-full">
        <img src="/images/banner.svg" alt="banner" />
      </div>
    </>
  );
};
